import { postAssessment } from '@actions/assessments';
import {
    getAssessmentsIsPosting,
    getAssessmentsPostError,
    getAssessmentsPostSuccess,
} from '@selectors/assessments';
import useForm from '@components/form/hooks/useForm';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PatchAssessment } from 'src/types/shared/Assessments';

const useCreateAssessmentForm = (applicationID: number, onSuccess: () => void) => {
    const dispatch = useDispatch();

    const isPosting = useSelector(getAssessmentsIsPosting);
    const postSuccess = useSelector(getAssessmentsPostSuccess);
    const postError = useSelector(getAssessmentsPostError);

    const [data, handleChange] = useForm<PatchAssessment>({
        applicationID,
        deploymentScale: 1,
        fitWithChallenge: 1,
        credibilityCompany: 1,
        credibilityTechnology: 1,
        fullOrPartialSolution: 1,
        isInnovative: false,
        finalComment: '',
    });

    const prevPostSuccess = usePrevious(postSuccess);
    useEffect(() => {
        if (!prevPostSuccess && postSuccess) onSuccess();
    }, [postSuccess, prevPostSuccess, onSuccess]);

    const handleSubmit = () => {
        dispatch(postAssessment(data));
    };

    return { data, handleChange, handleSubmit, isPosting, postSuccess, postError };
};

export default useCreateAssessmentForm;
